import Layout from "../../../hocs/Layout";

function TermsOfService() {
  return (
    <Layout products={true}>
      <div className="bg-white min-h-screen py-8">
        <div className="max-w-6xl mx-auto px-4">
          <h1 className="text-3xl font-bold mb-8">Terms of Service</h1>
          <div className="text-left">
            <p>Last updated: January 20, 2025</p>
            <h3 className="text-xl font-bold mt-4">
              1. Acceptance of these Terms
            </h3>
            <p>
              This terms and conditions agreement (hereinafter, "Agreement") is
              a legally binding contract between you and Histori.ai. By
              accessing or using the service, you agree to be bound by these
              terms, as well as the policies and guidelines incorporated into
              this Agreement.
            </p>
            <h3 className="text-xl font-bold mt-4">2. Your Content</h3>
            <p>
              You are solely responsible for all information, descriptions,
              images, posts, and any other material you upload or transmit
              through the service ("User Content"). Histori.ai is not
              responsible for the use that third parties make of your content.
            </p>
            <h3 className="text-xl font-bold mt-4">
              3. Restrictions on Use of the Service
            </h3>
            <ul className="list-disc list-inside">
              <li>
                Do not post content that infringes on intellectual property
                rights, privacy, or any legal rights of third parties.
              </li>
              <li>
                Do not reverse engineer, decompile, or manipulate the service's
                code.
              </li>
              <li>
                Do not access the service in a way that could damage, disable,
                or overload the platform.
              </li>
              <li>
                Do not use the service for illegal or fraudulent activities.
              </li>
            </ul>
            <h3 className="text-xl font-bold mt-4">4. Accounts</h3>
            <p>
              You are responsible for maintaining the confidentiality of your
              account and password. You must notify us immediately in case of
              unauthorized use of your account.
            </p>
            <h3 className="text-xl font-bold mt-4">5. Purchases and Sales</h3>
            <p>
              Histori.ai provides an online marketplace for buying and
              selling items. Buyers and sellers are solely responsible for
              transactions made through the platform.
            </p>
            <h3 className="text-xl font-bold mt-4">6. Refund Policy</h3>
            <p>
              All purchases are final and no refunds are allowed, except in
              cases expressly permitted by Histori.ai.
            </p>
            <h3 className="text-xl font-bold mt-4">7. Data Security</h3>
            <p>
              We implement security measures to protect your personal data,
              although we do not guarantee that the platform is free of
              vulnerabilities.
            </p>
            <h3 className="text-xl font-bold mt-4">
              8. Modifications to the Terms
            </h3>
            <p>
              We reserve the right to modify these terms at any time. If
              significant changes are made, we will notify you through the
              available means.
            </p>
            <h3 className="text-xl font-bold mt-4">9. Termination</h3>
            <p>
              We may suspend or terminate your account if you violate these
              terms. You may also delete your account at any time.
            </p>
            <h3 className="text-xl font-bold mt-4">10. Contact</h3>
            <p>
              For any questions or requests related to these terms, you can
              contact us at: support@Histori.ai
            </p>
          </div>
        </div>
      </div>
    </Layout>
  );
}

export default TermsOfService;
